var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletedLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Color / Me gusta Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.506,10.3447 C22.882,10.3447 21.258,10.9497 20,12.1597 C18.742,10.9497 17.118,10.3447 15.494,10.3447 C13.833,10.3447 12.172,10.9787 10.904,12.2467 C8.365,14.7847 8.365,18.9007 10.904,21.4387 L18.586,29.1197 C18.976,29.5107 19.488,29.7057 20,29.7057 C20.512,29.7057 21.024,29.5107 21.414,29.1197 L29.096,21.4387 C31.634,18.9007 31.634,14.7847 29.096,12.2467 C27.828,10.9787 26.167,10.3447 24.506,10.3447 M24.506,12.3447 C25.706,12.3447 26.834,12.8117 27.682,13.6607 C29.437,15.4147 29.437,18.2697 27.682,20.0247 L20,27.7057 L12.318,20.0247 C10.564,18.2697 10.564,15.4147 12.318,13.6607 C13.167,12.8117 14.295,12.3447 15.494,12.3447 C16.663,12.3447 17.771,12.7907 18.614,13.6007 L20,14.9337 L21.386,13.6007 C22.229,12.7907 23.337,12.3447 24.506,12.3447",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Color-/-Me-gusta-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.506,13.3447 C24.882,13.3447 23.258,13.9497 22,15.1597 C20.742,13.9497 19.118,13.3447 17.494,13.3447 C15.833,13.3447 14.172,13.9787 12.904,15.2467 C10.365,17.7847 10.365,21.9007 12.904,24.4387 L20.586,32.1197 C20.976,32.5107 21.488,32.7057 22,32.7057 C22.512,32.7057 23.024,32.5107 23.414,32.1197 L31.096,24.4387 C33.634,21.9007 33.634,17.7847 31.096,15.2467 C29.828,13.9787 28.167,13.3447 26.506,13.3447",
    id: "Mask",
    fill: "#FA504C"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#444444",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedLike);
export default __webpack_public_path__ + "static/media/completed-like.251216f3e7761dafd06e4ef2e61aca4f.svg";
export { ForwardRef as ReactComponent };